export const ACCESS_TOKEN_COOKIE = 'je-at'
export const ACCESS_TOKEN_TYPE = 'Bearer'
export const COOKIE_EXPIRY = 180
export const REFRESH_TOKEN_COOKIE = 'je-rt'
export const RENEW_TOKEN_URL = '/connect/token'
